/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateStoryDataSchema = z.object({
	imageId: z.string().uuid().nullable().optional(),
	title: z.string().nullable().optional(),
	subtitle: z.string().nullable().optional(),
	button: z.string(),
	location: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type UpdateStoryDataSchema = z.infer<typeof updateStoryDataSchema>
